import store from "@/store/";

export default async ({from, to, next}) => {
    console.log('middleware - themed');
    if(to.query.agent !== undefined)
    {
        const agent = to.query.agent;

        store.commit('subscription/setAgentCustomId', agent);
    }

    next();
}



// WEBPACK FOOTER //
// ./src/router/middleware/themed.js